<template>
    <div class="md-layout text-center login-fix-page">
        <div class="md-layout-item md-size-100">

        </div>
        <div
                class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
        >
            <form @submit.prevent="resetPassword">
                <login-card header-color="green">
                    <h4 slot="title" class="title">Reset  Your Password</h4>
                    <p slot="description" class="description">Password Reset</p>
                    <md-field
                            class="form-group md-invalid"
                            slot="inputs"
                            style="margin-bottom: 28px"
                    >
                        <md-icon>email</md-icon>
                        <label>Email...</label>
                        <md-input v-model="email" type="email" />
                    </md-field>
                  <validation-error :errors="apiValidationErrors.email" />
                  <div slot="inputs" v-if="isLoading" class="loading-container">
                    <md-progress-spinner md-mode="indeterminate" :md-diameter="diameter"></md-progress-spinner>
                    <span>Sending Reset Link...</span>
                  </div>

                    <md-button    class="md-simple md-success md-lg"  slot="footer">
                        <router-link to="/login">Login </router-link>
                    </md-button>
                    <md-button
                            slot="footer"
                            class="md-simple md-success md-lg"
                            type="submit"
                    >
                        send Email Reset Link
                    </md-button>
                </login-card>
            </form>
        </div>
    </div>
</template>

<script>
import { LoginCard, ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: {
        LoginCard,
        ValidationError,
    },
    mixins: [formMixin],
    computed: {
        isAuthenticated: function () {
            return this.$store.getters.isAuthenticated();
        },
    },
    data: () => ({
        email: null,
      isLoading: false,
      diameter:30
    }),
    methods: {
        async resetPassword () {
          this.isLoading = true;
            // const userEmail = {
            //     data: {
            //         type: 'resets',
            //         attributes: {
            //             email: this.email,
            //         },
            //     },
            // };

            const requestOptions = {
                headers: {
                    Accept: 'application/vnd.api+json',
                    'Content-Type': 'application/vnd.api+json',
                },
            };
            let url = `${process.env.VUE_APP_BASE_URL}/reset-process`;
            console.log(url);
            try {
                await this.$store.dispatch('resets/get', {  email: this.email,redirect_url:url, requestOptions });
              let successMessage = 'Password reset link has been sent to your email address. Please check your inbox.';
              this.email = '';

              // Show success alert
              this.notifySuccess('Reset link sent successfully');

            } catch (e) {
              this.notifyException(e)
                // await this.notifyError('Please enter existing email address to reset Your password');
                this.setApiValidation(e.response.data.errors);
            }finally {
              this.isLoading = false;
            }
        },
    },
};
</script>
<style scoped>
    .login-fix-page {
        padding-bottom: 7em;
        padding-top: 4em;
    }
</style>
